import { AnnotationToolbarSubMenuFill } from "./annotation-toolbar-sub-menu-fill";
import { AnnotationToolbarSubMenuFontSize } from "./annotation-toolbar-sub-menu-font-size";
import { AnnotationToolbarSubMenuOffset } from "./annotation-toolbar-sub-menu-offset";
import { AnnotationToolbarSubMenuPattern } from "./annotation-toolbar-sub-menu-pattern";
import { AnnotationToolbarSubMenuStroke } from "./annotation-toolbar-sub-menu-stroke";
import { AnnotationToolbarSubMenuText } from "./annotation-toolbar-sub-menu-text";
import { AnnotationToolbarSubMenuTilt } from "./annotation-toolbar-sub-menu-tilt";
import { AnnotationToolbarSubMenuUnit } from "./annotation-toolbar-sub-menu-unit";
import type { AnnotationToolbarUpdateTarget } from "./shared";

/** Props Interface */
interface AnnotationToolbarSubMenuProps {
	target: AnnotationToolbarUpdateTarget;
}

export function AnnotationToolbarSubMenu({ target }: AnnotationToolbarSubMenuProps) {
	/** Render */
	return (
		<div
			className="absolute left-0 right-0 bottom-full mb-2 rounded-2xl border-[0.5px] border-primary-700 bg-primary-950 p-4"
			onClick={(e) => e.stopPropagation()}
		>
			{target === "stroke" && <AnnotationToolbarSubMenuStroke />}
			{target === "text" && <AnnotationToolbarSubMenuText />}
			{target === "font-size" && <AnnotationToolbarSubMenuFontSize />}
			{target === "unit" && <AnnotationToolbarSubMenuUnit />}
			{target === "offset" && <AnnotationToolbarSubMenuOffset />}
			{target === "tilt" && <AnnotationToolbarSubMenuTilt />}
			{target === "fill" && <AnnotationToolbarSubMenuFill />}
			{target === "pattern" && <AnnotationToolbarSubMenuPattern />}
		</div>
	);
}
